export default {
  id: 159,
  title: 'Target #159 - Portal',
  url: 'https://cssbattle.dev/play/159',
  colors: ['#F5D6B4', '#D86F45'],
  solution:
    '<p a><p b><p c><p d><p e><style>body{background:#f5d6b4}p{position:fixed;top:9;background:#d86f45;width:50;height:250}[a]{left:75}[b]{left:125}[c]{left:175}[d]{left:225}[e]{left:275}[a],[e]{transform:rotatex(78.5deg)}[b],[d]{transform:rotatex(53deg)}</style>',
}
